import {
    scrollTo,
    shrinkWrap as shrinkWrapElement,
    unshrinkWrap as unshrinkWrapElement,
    loadSvg,
} from '../common/utils';

const reverse = function () {
    return $($(this).get().reverse());
};

const preciseWidth = function () {

    return $(this).get(0).getBoundingClientRect().width;
};

const preciseHeight = function () {

    return $(this).get(0).getBoundingClientRect().height;
};

const slideDown = function () {

    if ($(this).is(':visible')) return;

    const initialHeight = $(this).data('initialHeight');

    gsap.set(
        $(this),
        {
            display: 'block',
            height: 0,
            overflow: 'hidden',
        }
    );

    gsap.to(
        $(this),
        {
            height: initialHeight,
            ease: 'none',
            duration: 0.3,
            onComplete: () => {
                gsap.set(
                    $(this),
                    { clearProps: 'display,height,overflow' }
                );
            },
        }
    );

    return $(this);
};

const slideUp = function () {

    if (!$(this).is(':visible')) return;

    $(this).data('initialHeight', $(this).height());

    gsap.set($(this), { overflow: 'hidden' });

    gsap.to(
        $(this),
        {
            height: 0,
            onComplete: () => {
                gsap.set($(this), { display: 'none' });
            },
        }
    );

    return $(this);
};

const scrollIntoView = function (options = {}) {

    scrollTo($(this), options);

    return $(this);
};

const shrinkWrap = function () {

    shrinkWrapElement($(this));

    return $(this);
};

const unshrinkWrap = function () {

    unshrinkWrapElement($(this));

    return $(this);
};

const customizeSelect2 = function () {

    const vendor = $.fn.select2;

    return function () {

        const instance = vendor.apply(this, arguments);

        $(this)
            .siblings('.select2')
            .find('.select2-selection__arrow')
            .empty()
            .html(
                loadSvg('caret')
            );

        return instance;
    };
};

const register = () => {

    $.fn.reverse = reverse;

    $.fn.preciseWidth = preciseWidth;
    $.fn.preciseHeight = preciseHeight;

    $.fn.slideDown = slideDown;
    $.fn.slideUp = slideUp;
    $.fn.scrollIntoView = scrollIntoView;
    $.fn.shrinkWrap = shrinkWrap;
    $.fn.unshrinkWrap = unshrinkWrap;

    $.fn.select2 = customizeSelect2();
};

export default {
    register,
};

